import React, { useEffect, useState } from "react";
import "../../Assets/css/paymentOptions.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Slide,
  Snackbar,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
import PaymentRedirectForm from "../../AgentAuthentication/HdfcErgoKYC/Utilities/PaymentRedirectForm";
import CryptoJS from "crypto-js";
import { QUICK_QUOTE_ROUTE } from "../../HealthInsuranceNew/routes";
import { getLocalData } from "../../Utilities/Common/source";
import axiosInstance from "../../Utilities/djangoAxiosInstance";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const PaymentOptions = () => {
  const Axios = axiosInstance
  const { referencetId } = useParams();
  const referencetIdArray = referencetId.split("*");
  //const refID = referencetIdArray[0]
  //const goldManId = referencetIdArray[1]
  const [responseData, setResponseData] = useState({});
  const [paymentDetail, setPaymentDetail] = useState({});
  const [sendSMS, setSendSMS] = useState(false);
  const [msgForSMSButton, setMsgForSMSButton] = useState(
    "Send payment link to customer"
  );
  const navigate = useNavigate();

  const { state } = useLocation();
  const [clickedPayHere, setClickedPayHere] = useState(false);
  const [nextButtonStatus, setNextButtonStatus] = useState(false);
  const [clickedSendLink, setClickedSendLink] = useState(false);

  const localSource = getLocalData("source");
  console.log("PaymentOption localSource: ", localSource);
  useEffect(() => {
    //console.log(referencetId)
    /* http://api.acuvisor.in/api/health/createquote-response/ */
    let domain = "";
     
    Axios.get(`api/health/transfer-data/${referencetId}`, {
      params: {
        source: localSource,
      },
    }).then((response) => {
      console.log("respon", response);

      Axios.get(
        `api/payment-details/${response.data.A_id}/${response.data.Acuvisor_product_id}`,
        {
          params: {
            source: localSource,
          },
        }
        //`${domain}/api/health/createquote-response/${referencetId}/`
      ).then((paymentResponse) => {
        console.log("paymentResponse", paymentResponse);

        setPaymentDetail(paymentResponse.data);
      });
      setResponseData(response.data);
    });
  }, []);

  const backButtonHandler = () => {
    Swal.fire({
      title: "Proposal already generated",
      text: "Proceed to payment or go back to quick quote.",
      icon: "warning",
      confirmButtonColor: "#0d409b",
      cancelButtonColor: "#d33",
      confirmButtonText: "Proceed to Payment",
      cancelButtonText: "Go to Quick Quote",
      showCancelButton: true,

      reverseButtons: true,
    }).then((result) => {
      const stateToPass = {
        source: getLocalData("source"),
      };
      if (result.dismiss === Swal.DismissReason.cancel) {
        navigate(QUICK_QUOTE_ROUTE, { state: stateToPass });
      }
    });
  };

  const sendLink = async () => {
    setClickedSendLink(true);
    let domainDjango = "";
    if (window.location.hostname === "localhost") {
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    await Axios.get(
      `api/send-payment-link/${responseData.A_id}/${responseData.Acuvisor_product_id}/${referencetId}`
      //`https://dev.acuvisor.com/V2/AcuHealthInsurance/health_policy_payment_link?enquiryId=${responseData.A_id}&referenceId=${referencetId}`
    ).then((response) => {
      console.log("fffss", response);
      if (response.data[0].status) {
        setSendSMS(true);
        setMsgForSMSButton("A sms will be sent to the customer");
      }
      //console.log('data', response.data)
    });
  };

  const handleCloseSlack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSendSMS(false);
  };

  const payHere = () => {
    //console.log('link', responseData.proposalNum)
    console.log("vendor", responseData.vendor);
    setClickedPayHere(true);
    if (
      responseData.vendor === "Star Health" ||
      responseData.vendor === "Care Health"
    ) {
      window.open(`${paymentDetail.paymentUrl}`);
    } else if (responseData.vendor === "Go Digit") {
      window.location.href = paymentDetail.paymentUrl;
    } else if (responseData.vendor === "HDFC Ergo") {
      // console.log("HDFC Payment is Pending !")
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }
      let paymenturi =
        "/api/hdfc-payment/" +
        responseData.product_ref +
        "/" +
        referencetId +
        "/null/";
      console.log(paymenturi);
      Axios.post(
        paymenturi,
        {
          pay_person: localSource === "b2c" ? "b2cCustomer" : "posp",
        },
        {
          params: {
            source: localSource,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            console.log("Get Checksum", response.data);
            const Checksum = response.data;

            PaymentRedirectForm(Checksum);
          }
        })
        .catch((e) => {
          alert(e);
        });

      // PaymentRedirectForm(checksum);
    } else {
      let domain = "";
      //window.open(`https://apiuat.religarehealthinsurance.com/portalui/PortalPayment.run?proposalNum=${responseData.proposalNum}&returnURL=http://localhost:3001/health-insurance/policy-status/${responseData.proposalNum}`)
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;

        /* console.log('host', window.location.hostname)
                window.open(`http://localhost:8000/api/care-payment/?proposalNum=${responseData.proposalNum}*${referencetId}`) */
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;

        /* console.log('host', window.location.hostname)
                window.open(`http://3.111.231.158:8000/api/care-payment/?proposalNum=${responseData.proposalNum}`) */
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;

        /*  console.log('host', window.location.hostname)
                 window.open(`http://65.0.70.70:8000/api/care-payment/?proposalNum=${responseData.proposalNum}`) */
      }
      console.log("host", window.location.hostname);
      window.open(
        `${domain}/api/care-payment/?proposalNum=${responseData.proposalNum}`
      );
    }
  };

  const checkPaymentStatus = (A_id) => {
    let isPaymentEarly =
      responseData.product_code === "2828" || "2825" ? true : false;
    let domain = "";
     

    Axios.get(`api/check-status/${A_id}/`).then((response) => {
      console.log("check Status", response);

      if (response.data.policyStatus === 7) {
        setNextButtonStatus(isPaymentEarly);
        Swal.fire({
          icon: "success",
          title: "Your Transaction is successfull",
          //text: '',
          position: "center",
        }).then((result) => {
          console.log("swl", result);
          /* if (result.isConfirmed) {
            navigate(
              `/life-insurance/paypremium/${transferData.payment_config_id}*${transId}*${validateFormid}`
            );
          } */
        });
      } else if (response.data.policyStatus === 4) {
        Swal.fire({
          icon: "warning",
          title: "Payment Transaction Failed !",
          text: "User payment transaction has failed ,Try again !",
          position: "center",
        });
        setSendSMS(false);
        setMsgForSMSButton("Send Link to Customer Again !");
        setClickedSendLink(false);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Check the status again After 10mins",
          //text: '',
          position: "center",
        });
      }
    });
  };
  const nextHandler = () => {
    let encryptedProduct_ref = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(responseData.product_ref),
        "secret key @123"
      ).toString()
    );
    let encryptedDataId = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(referencetId),
        "secret key @124"
      ).toString()
    );

    let path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
    navigate(path);
  };

  return (
    <>
      {/*  {console.log('nnn', typeof (responseData.number_of_insured))} */}
      <div>
        <div className="header-section">
          <p className="insurence-title-sec">
            Health Insurance
            <KeyboardArrowDownIcon />
          </p>
        </div>
        <Container
          style={{ marginTop: 10, marginBottom: 10 }}
          maxWidth="sm md lg"
        >
          <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
            <Box sx={{ display: "flex", marginBottom: 4 }}>
              <img
                className="bg-white img-thumbnail rounded"
                width={100}
                height={100}
                src={responseData.logo}
              />
              <Box style={{ margin: 16 }}>
                <Typography>{responseData.vendor}</Typography>
                <Typography>{responseData.product_name}</Typography>
              </Box>
            </Box>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <Typography>Proposer Name:</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>
                    <strong>{responseData.proposerName}</strong>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography>Policy Type:</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>
                    <strong>
                      {responseData.number_of_insured > 1
                        ? "Floater"
                        : "Individual"}
                    </strong>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography>Number of Insured(s):</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>{responseData.number_of_insured} </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography></Typography>
                </Grid>
                <hr />
                <Grid item xs={3}></Grid>
                <Grid item xs={6} color="text.primary" style={{}}>
                  <Typography>
                    <b>Premium Details</b>
                  </Typography>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={8}>
                  <Typography>Policy Premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {paymentDetail.premium !== null
                      ? paymentDetail.premium
                      : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>Tax On Premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {paymentDetail.serviceTax !== null
                      ? paymentDetail.serviceTax
                      : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>Gross premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {paymentDetail.TotalPremium}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <div className="button-section">
            {sendSMS ? (
              <div>
                {localSource !== "b2c " && (
                  <div>
                    <button
                      className="pay-btn "
                      //type="button"
                      onClick={
                        () => checkPaymentStatus(responseData.A_id)
                        //getPaymentStatusData(transferData.UserID,'BCE8A8D85CA47E0',transferData.A_id)
                      }
                    >
                      Check Status
                    </button>
                  </div>
                )}
                <div>
                  {nextButtonStatus ? (
                    <button
                      className="pay-btn "
                      type="button"
                      onClick={nextHandler}
                    >
                      Next
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <div>
                {localSource !== "b2c" && (
                  <div>
                    {clickedSendLink ? (
                      <Box
                        className="mx-auto"
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress
                          size={48}
                          sx={{
                            color: "red",
                          }}
                        />
                      </Box>
                    ) : (
                      <button
                        className="payment-btn"
                        type="button"
                        onClick={sendLink}
                        disabled={
                          msgForSMSButton ===
                          "A sms will be sent to the customer"
                            ? true
                            : false
                        }
                      >
                        {msgForSMSButton}
                      </button>
                    )}
                    <Snackbar
                      open={clickedSendLink}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      autoHideDuration={5000}
                      TransitionComponent={TransitionLeft}
                      onClose={handleCloseSlack}
                    >
                      <Alert severity="success" onClose={handleCloseSlack}>
                        A sms will be sent to the customer
                      </Alert>
                    </Snackbar>
                  </div>
                )}
                <div>
                  {clickedPayHere ? (
                    <Box
                      className="mx-auto"
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress
                        size={48}
                        sx={{
                          color: "red",
                        }}
                      />
                    </Box>
                  ) : (
                    <button
                      className="pay-btn "
                      type="button"
                      onClick={payHere}
                    >
                      Pay here
                    </button>
                  )}
                </div>
              </div>
            )}

            <div>
              <button
                className="back-btn"
                type="button"
                onClick={backButtonHandler}
              >
                Back
              </button>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default PaymentOptions;
